import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import ISPs from "../components/ISPs/ISPs";
import MDUs from "../components/ISPs/MDUs";

const Isps = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div>
      <Box sx={{ px: 4, pt: 8, pb: 4 }}>
        <Typography variant="h3" className="sectionTitle">
          ISPs / Cable Providers
        </Typography>
        <Typography sx={{ mt: 4, textAlign: isMobile ? "left" : "justify" }} variant="body1">
            Internet Service Providers (ISPs) and Cable Operators share an essential commodity; customers. To keep these customers, it is important to offer them options and flexibility. Enter SivooTV+, a streaming platform that caters to users with options and flexibility&mdash;and provides ISPs and cable operators a strategy for retention and upside to the bottom line. For more information, <Link to="mailto:sales@sivoo.com?subject=SivooTV+Plus+Platform" target="_blank">contact</Link> us to schedule a call.
        </Typography>
      </Box>
      <ISPs />
      <Box sx={{ px: 4, pt: 8, pb: 4 }}>
        <Typography variant="h3" className="sectionTitle">
          MDUs
        </Typography>
        <Typography sx={{ mt: 4, textAlign: isMobile ? "left" : "justify" }} variant="body1">
            Multiple Dwelling Units (MDUs) are unique properties in that all the residents/guests receive the same video package. With higher unit counts, there presents an opportunity for management to consider SivooTV+ as well. Users would automatically get a base package and depending on the property type (residential or commercial) there are additional packages for which upgrades may be available. For more information, <Link to="mailto:sales@sivoo.com?subject=SivooTV+Plus+Platform" target="_blank">contact</Link> us to schedule a call.
        </Typography>
      </Box>
      <MDUs />
    </div>
  );
};

export default Isps;
